import Is from './is.js'
import Toast from './toast.js'

export default class Network
{
	static init()
	{
		$('input[type="submit"], button[type="submit"]').on('click', function()
		{
			this.form.setAttribute('__action', $(this).data('action') || 'submit')
			if($(this).data('confirm') !== null) this.form.setAttribute('__confirm', $(this).data('confirm') || '更新しますか？')
		})
	}

	static form_post(form, callback)
	{
		try
		{
			if(form.getAttribute('__confirm') && !confirm(form.getAttribute('__confirm'))) return false

			$('.__editor').each((index, element) =>
			{
				$(element).data('editor').updateSourceElement()
			})

			const data = new FormData(form)
			data.set('__action', form.getAttribute('__action') || 'submit')

			Network.post(form.action || location.pathname, data, callback)
		}
		catch(exception)
		{
			console.error(exception.message)
		}

		return false
	}

	static post(url, data, callback)
	{
		(async () =>
		{
			try
			{
				// Without a file, send URL-encoded: nginx blocks multipart outside master
				if(data instanceof FormData && ![...data.values()].some(value => value instanceof File)) data = new URLSearchParams(data)

				let response = await $.ajax({
					url   : url,
					method: 'POST',

					data: data,

					contentType: false,
					processData: false,
				})

				if(typeof response !== 'object') response = {message: null, success: false}
				if(typeof response.success !== 'boolean') response.success = false

				if(!response.success)
				{
					Toast.warning(response.message)
				}
				else
				{
					if(Is.filled(response.message)) Toast.success(response.message)
				}

				if(typeof callback === 'function')
				{
					// noinspection JSUnresolvedVariable
					callback(response.success, response.payload)
				}
			}
			catch(exception)
			{
				let error = exception.message !== undefined ? exception.message : `HTTP ${exception.status} : エラーが発生しました`
				Toast.error(error)
			}
		})()
	}
}
